import { IFormatSpecification } from "../IFormatSpecification";
import { ISelectableObject } from "../objects";
import { ITextStyleSelectable } from "../properties";
import { AbstractStandardTextDrawableObjectEditor } from "./AbstractStandardTextDrawableObjectEditor";


export abstract class AbstractSelectableObjectEditor<TObject extends ISelectableObject> extends AbstractStandardTextDrawableObjectEditor<TObject> implements ITextStyleSelectable {
  constructor(source: TObject | AbstractSelectableObjectEditor<TObject>, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._textStyle = this.createPropertyEditor(
      s => s.textStyle,
      (s, v) => s.textStyle = {
        fontStyle: {
          color: s.textStyle.fontStyle.color, // 選択項目の色が使われるのでフォーマット編集では設定しない.前値維持.
          font: v.fontStyle.font,
        },
        paintStyle: s.textStyle.paintStyle,   // 選択項目の色が使われるのでフォーマット編集では設定しない.前値維持.
        alignment: v.alignment,
      });
    this._scriptExecuteTriggerBehavior = this.createScriptExecuteTriggerBehaviorPropertyEditor(s => true);
    this._emptyAlertAllowBehavior = this.createEmptyAlertAllowBehaviorPropertyEditor(s => true);
    this._groupAlertAllowBehavior = this.createGroupAlertAllowBehaviorPropertyEditor(s => true);
  }

  isFontColorSelectable(): boolean {
    return true;
  }

  isPaintColorSelectable(): boolean {
    return true;
  }

  getWarningName(): string {
    return this._name.getValue();
  }

  getWarningSettingName(): string {
    return this._name.getValue();
  }

  isSettableWarningName(): boolean {
    return true;
  }
}
